export enum EltType {
  Pptx = 1,
  Doc = 2,
  DocOctober25 = 3,
  DocJanuary26 = 4,
}
